/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoInputTextComponent = {
    template: require('./gmao-input-text.html'),
    bindings: {
        model: '=',
        modelOptions: '<',
        validationError: '<',
        disabled: '<',
        readonly: '<',
        required: '<',
        maxLength: '<',
        placeholderKey: '<',
        hintKey: '<',
        labelNoFloat: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoInputText.js